import type { ChromeCopy } from '../types/chrome';

export const chromeIt: ChromeCopy = {
  siteMeta: {
    defaultTitle: 'SafestMenu - Menu con codice QR per ristoranti | safestmenu.com',
    defaultDescription:
      'Crea con SafestMenu su safestmenu.com un menu digitale multilingue con codice QR. I clienti scansionano; tu aggiorni i prezzi. Inizia gratis.',
  },
  header: {
    homeAriaLabel: 'Home di SafestMenu',
    mainNavAriaLabel: 'Principale',
    mobileNavAriaLabel: 'Cellulare',
    nav: {
      why: 'Perché SafestMenu',
      howItWorks: 'Come funziona',
      aboutUs: 'Chi siamo',
    },
    ctaLabel: 'Apri l’app',
    openMenuAriaLabel: 'Apri il menu',
    closeMenuAriaLabel: 'Chiudi il menu',
  },
  footer: {
    tagline:
      'Il menu con codice QR per ristoranti, bar e caffetterie. Facile da configurare, sicuro per i tuoi clienti, gentile con la natura.',
    siteNavAriaLabel: 'Sito',
    legalNavAriaLabel: 'Legale',
    exploreHeading: 'Esplora',
    companyHeading: 'Azienda',
    nav: {
      why: 'Perché SafestMenu',
      howItWorks: 'Come funziona',
      allergenGuide: 'Guida agli allergeni UE',
      blog: 'Blog',
      openApp: 'Apri l’app',
      aboutUs: 'Chi siamo',
      impressum: 'Impressum',
      terms: 'Termini e condizioni',
      transfactorDev: 'transfactor.dev',
    },
    craftedBy: 'Realizzato da',
    copyrightSuffix: 'SafestMenu. Tutti i diritti riservati.',
  },
  consent: {
    message:
      'Utilizziamo i cookie per analisi e per misurare le prestazioni pubblicitarie. Puoi accettare o rifiutare - il sito funziona allo stesso modo in entrambi i casi. Non li usiamo per personalizzare gli annunci.',
    decline: 'Rifiuta',
    accept: 'Accetta',
    settings: 'Impostazioni cookie',
  },
  languageSwitcher: {
    label: 'Cambia lingua',
  },
  localeSuggestion: {
    message: 'Questa pagina è disponibile anche in italiano.',
    accept: 'Vedi in italiano',
    dismiss: 'No, grazie',
  },
  emailCapture: {
    defaultTitle: 'Ricevi consigli sul menu via email',
    defaultDescription:
      'Consigli pratici, ogni tanto, su menu, allergeni e come gestire un ristorante senza carta. Niente spam.',
    defaultPlaceholder: 'tu@ristorante.com',
    defaultButtonLabel: 'Iscriviti',
    emailLabel: 'Indirizzo email',
    loadingButtonLabel: 'Iscrizione in corso…',
    successMessage: 'Sei nella lista. Tieni d’occhio la tua casella per i consigli sul menu.',
    errorMessage: 'Qualcosa è andato storto. Riprova tra un momento.',
  },
  qrPlate: {
    linkAriaLabel: 'Scansiona o tocca per aprire il menu demo live di SafestMenu',
    svgAriaLabelPrefix: 'Codice QR che rimanda a ',
    caption: 'Scansiona o clicca - è reale',
  },
  notFound: {
    seoTitle: 'Pagina non trovata',
    heading: 'Questo piatto non è nel menu.',
    message: 'La pagina che stai cercando non esiste o è stata spostata.',
    backLabel: 'Torna al menu',
  },
  blog: {
    seoTitle: 'Blog',
    seoDescription:
      'Consigli pratici su menu con QR, esperienza dei clienti e come gestire un ristorante senza carta.',
    eyebrow: 'Blog',
    heading: 'Consigli su menu, clienti e come gestire un ristorante senza carta.',
    emptyMessage: 'Nuovi articoli in arrivo.',
  },
};
